import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Save `type` for every session
 * - Save `generated` for every script
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v8---')

  const sessionStore = transaction.objectStore('sessions')
  const scriptStore = transaction.objectStore('scripts')

  // First, we get all sessions
  const sessionsRequest = sessionStore.getAll()
  sessionsRequest.onsuccess = () => {
    const sessions = sessionsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all sessions', sessions)

    // Then, for each session, set the `type`
    asyncForEach(
      sessions,
      (session, next) => {
        STUDIO_ENV_DEVELOPMENT && console.log('Updating session', session)
        session.type = session.scriptId ? 'script' : 'fallback'
        STUDIO_ENV_DEVELOPMENT && console.log('Adding theme', session.tabOrder)
        sessionStore.put(session).onsuccess = next
      },
      () => {
        // Next, we get all scripts
        const scriptsRequest = scriptStore.getAll()
        scriptsRequest.onsuccess = () => {
          const scripts = scriptsRequest.result
          STUDIO_ENV_DEVELOPMENT && console.log('Found all scripts', scripts)

          // Then, for each session, set the `type`
          asyncForEach(
            scripts,
            (script, next) => {
              STUDIO_ENV_DEVELOPMENT && console.log('Updating script', script)
              script.generated = false
              STUDIO_ENV_DEVELOPMENT &&
                console.log('Adding theme', script.tabOrder)
              scriptStore.put(script).onsuccess = next
            },
            () => {
              STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v8---')
              return next()
            }
          )
        }
      }
    )
  }
}
